import { render, staticRenderFns } from "./SendGoods.vue?vue&type=template&id=dccaa508&scoped=true&"
import script from "./SendGoods.vue?vue&type=script&lang=js&"
export * from "./SendGoods.vue?vue&type=script&lang=js&"
import style0 from "./SendGoods.vue?vue&type=style&index=0&id=dccaa508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccaa508",
  null
  
)

export default component.exports